// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
Vue.prototype.$axios = axios
//Vant，现在是导入所有的组件，可以修改按需
// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);
Vue.config.productionTip = false
//配置页面config
import config from './api/config'
Vue.prototype.$config = config;
//所有api请求
import HttpRequest from './api/api'
Vue.prototype.$http = HttpRequest;
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js